import React from 'react';


class UserIcon extends React.Component {
	//Classing this out so the icon file parsing doesn't clutter up the user display and so this can be used independently of an actual user
	constructor(props) {
		super(props);

		this.onIconClick = this.onIconClick.bind(this);
	}
	getIconFile(accessLevel) {
		//This is stub code, it will actually parse for the image once we have it
		return '/images/accesslevelgreen.png';
	}

	onIconClick(e) {
		////console.log("UserIcon.onClick");
		if(this.props.onALClick) this.props.onALClick(e);
	}

	render() {

		const image = this.getIconFile(this.props.accessLevel);

		return (
			<div className="App-SideBarUserIcon" onClick={this.onIconClick} >
				<img src={image} alt="User Access Icon" />
			</div>
			);
	}

}

class UserName extends React.Component {
	//Classing htis out because we may want it to do something later (such as contextually render additional text, etc.)
	render() {

		return (
			<div className="App-SideBarUserName">
				<p style={{fontSize: "1.5vmin", fontWeight : "300"}}>Logged in as</p>
				<p>{this.props.name}</p>
			</div>
		);

	}

}

class UserDisplay extends React.Component {

	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	onClick() {
		this.props.onClick();
	}

	render() {
		const name = this.props.name;
		const accessLevel = this.props.accessLevel;

		////console.log(this.props.onALClick);

		return (
			<div className="App-UserDisplay">
				<UserIcon accessLevel={accessLevel} onALClick={this.props.onALClick}  />
				<UserName name={name} />
			</div>
		);
	}
}

export {UserIcon, UserName, UserDisplay};